module.exports = __webpack_public_path__ + "static/media/token-logo.57d8319b.svg";